module.exports = __webpack_public_path__ + "img/guarantee-consign.4a08e3a7.png";